/**
 * A config containing properties for cards
 */
export class CardConfigBase {
  /**
   * Title for the card
   */
  title?: string;

  /**
   * Show a border after the title and sub-title.
   */
  titleBorder?: boolean;

  /**
   * Show a border above the card title.
   */
  topBorder?: boolean;
}
